import React from "react";
import { Box, Typography } from "@mui/material";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";
function Header({ banner, label1, label2, button, width }) {
  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/experience");
  };

  return (
    <Box
      sx={{
        height: "95vh",
        backgroundImage: `url(${banner})`,
        backgroundSize: "100% 100%",
        backgroundPosition: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
        textAlign: "center",
        padding: { xs: "20px", sm: "40px" },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.1)", 
          // zIndex: 1,
        },
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2rem", sm: "3rem", md: "5rem" },
          fontWeight: "bold",
          marginBottom: 2,
          width: width && width,
        }}
      >
        {label1}
      </Typography>
      {label2 && (
        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "1rem", sm: "1.25rem", md: "18px" },
            maxWidth: "600px",
            marginBottom: 4,
          }}
        >
          {label2}
        </Typography>
      )}
      {button && (
        <Box sx={{ width: "fit-content" }}>
          <CustomButton onClick={handleNavigation} cursor="pointer">Book Your Experience</CustomButton>{" "}
        </Box>
      )}
    </Box>
  );
}

export default Header;
